import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import {
  requestTechnicianVerification,
  requestTechnicianVerificationOnPortalSide,
  checkCodeVerifyTechnician,
} from 'services/verificationRequest';

export const ThunkRequestTechnicianVerification = createAsyncThunk(
  `${storeResources.VERIFICATION_REQUEST}/requestTechnicianVerification`,
  () => requestTechnicianVerification().then(res => res.data),
);

export const ThunkRequestTechnicianVerificationOnPortalSide = createAsyncThunk(
  `${storeResources.VERIFICATION_REQUEST}/requestTechnicianVerificationOnPortalSide`,
  () => requestTechnicianVerificationOnPortalSide().then(res => res),
);

export const ThunkCheckCodeVerifyTechnician = createAsyncThunk<any, any>(
  `${storeResources.VERIFICATION_REQUEST}/checkCodeVerifyTechnician`,
  payload => checkCodeVerifyTechnician(payload).then(res => res.data),
);
